import { gql } from '@apollo/client';

const daySequenceFragment = gql`
  fragment DaySequenceFragment on DaySequence {
    id
    dateTime
    shiftDuration
    shiftDurationUnit
    jobId
    status
    userId
    startDate
    endDate
    startDateISO
    clockInTime
    clockOutTime
    clockInGeo {
      lat
      lng
      accuracyMeters
      capturedAt
    }
    clockOutGeo {
      lat
      lng
      accuracyMeters
      capturedAt
    }
    clockInByUserId
    clockOutByUserId
    createdByUserId
    updatedByUserId
    proposedClockInTime
    proposedClockOutTime
    isOpenEnded
    clientId
    breaks {
      daySequenceId
      startTime
      endTime
      duration
      type
    }
    proposedBreaks {
      daySequenceId
      startTime
      endTime
      duration
      type
    }
  }
`;

export const GET_DAY_SEQUENCES_REQUIRING_ACTION = gql`
  ${daySequenceFragment}
  query GetDaySequencesRequiringAction($tenantId: String!) {
    getDaySequencesRequiringAction(tenantId: $tenantId) {
      ...DaySequenceFragment
    }
  }
`;

export const GET_DAY_SEQUENCES_FOR_CLIENT = gql`
  ${daySequenceFragment}
  query GetDaySequencesForClient($clientId: String!) {
    getDaySequencesForClient(clientId: $clientId) {
      ...DaySequenceFragment
    }
  }
`;

export const GET_DAY_SEQUENCE = gql`
  ${daySequenceFragment}
  query GetDaySequencesForJob(
    $jobId: String!
    $limit: Int
    $lastEvaluatedKey: String
  ) {
    getDaySequencesForJob(
      jobId: $jobId
      limit: $limit
      lastEvaluatedKey: $lastEvaluatedKey
    ) {
      daySequences {
        ...DaySequenceFragment
      }
      hasMore
      lastEvaluatedKey
    }
  }
`;

export const GET_DAY_SEQUENCES_BY_JOB_IDS = gql`
  ${daySequenceFragment}
  query GetDaySequencesByJobIds($jobIds: [String!]!) {
    getDaySequencesByJobIds(jobIds: $jobIds) {
      ...DaySequenceFragment
    }
  }
`;

export const GET_DAY_SEQUENCES_FOR_USER = gql`
  ${daySequenceFragment}
  query GetDaySequencesForUser(
    $userId: String!
    $statuses: [DaySequenceStatus!]
  ) {
    getDaySequencesForUser(userId: $userId, statuses: $statuses) {
      ...DaySequenceFragment
    }
  }
`;

export const CLOCK_ACTION = gql`
  ${daySequenceFragment}
  mutation ClockAction($entry: ClockEntryInput!) {
    clockAction(entry: $entry) {
      ...DaySequenceFragment
    }
  }
`;

export const APPROVE_DAY_SEQUENCES = gql`
  ${daySequenceFragment}
  mutation ApproveDaySequences($ids: [String!]!) {
    approveDaySequences(ids: $ids) {
      ...DaySequenceFragment
    }
  }
`;

export const DISPUTE_DAY_SEQUENCES = gql`
  ${daySequenceFragment}
  mutation DisputeDaySequences($ids: [String!]!) {
    disputeDaySequences(ids: $ids) {
      ...DaySequenceFragment
    }
  }
`;

export const PROPOSE_DAY_SEQUENCE_CHANGES = gql`
  ${daySequenceFragment}
  mutation ProposeDaySequenceChanges(
    $daySequenceChanges: [DaySequenceChangeInput!]!
  ) {
    proposeDaySequenceChanges(daySequenceChanges: $daySequenceChanges) {
      ...DaySequenceFragment
    }
  }
`;

export const RESOLVE_DAY_SEQUENCE_DISPUTES = gql`
  ${daySequenceFragment}
  mutation ResolveDaySequenceDisputes(
    $daySequenceChanges: [DaySequenceChangeInput!]!
  ) {
    resolveDaySequenceDisputes(daySequenceChanges: $daySequenceChanges) {
      ...DaySequenceFragment
    }
  }
`;

export const CREATE_DAY_SEQUENCES = gql`
  ${daySequenceFragment}
  mutation CreateDaySequences($input: CreateDaySequenceInput!) {
    createDaySequences(input: $input) {
      ...DaySequenceFragment
    }
  }
`;
